var _ = require('underscore');

var React = require("react");
var ReactDOM = require("react-dom");
const createReactClass = require("create-react-class");

var form = require("../../deploynaut/js/Form.jsx");

var StackPicker = createReactClass({
	mixins: [form.InputMixin],

	getInitialState: function() {
		return {
			optionsExpanded: false
		};
	},

	componentWillReceiveProps: function(nextProps) {
		if (_.isArray(nextProps.enabledTypes) && nextProps.enabledTypes.length===1) {
			// Force the only available selection.
			this.setState({
				value: nextProps.enabledTypes[0]
			});
		} else {
			// Wipe the selection if anything has changed - user needs to reasses.
			var specHasChanged = (
				!_.isEqual(nextProps.enabledTypes, this.props.enabledTypes)
				|| !_.isEqual(nextProps.stackSpecs['trial'], this.props.stackSpecs['trial'])
			);
			if (specHasChanged) {
				this.setState({
					value: null
				});
			}
		}
	},

	onClick: function(e) {
		this.setState({
			optionsExpanded: !this.state.optionsExpanded
		});
	},

	onChange: function(e) {
		this.setValue(e);

		// Close the dropdown.
		var self = this;
		setTimeout(function(){
			self.setState({
				optionsExpanded: false
			});
		}, 100);
	},

	/**
	 * Make the dropdown close on blur.
	 *
	 * Focus property is not inherited across elements, so we have to manually check
	 * if the blur event took focus away entirely from the picker. If we are merely
	 * changing focus to an element inside the picker then we shouldn't close the dropdown.
	 *
	 * The blur event is inherited, so this handler will trigger every time the main
	 * element or any of the descendants loose focus.
	 */
	onBlur: function(e) {
		var self = this;
		// Wait a tick so the new element can come in focus.
		setTimeout(function(){
			if (!ReactDOM.findDOMNode(self.refs.inputElement).contains($(':focus')[0])) {
				self.setState({
					optionsExpanded: false
				});
			}
		}, 100);
	},

	render: function () {
		var self = this;

		var className = 'form-control';
		var alert;
		if (!this.state.isValid) {
			alert = <div className='validation-message'>{this.state.serverError || this.props.validationError}</div>;
			className += ' validation-error';
		}

		var pickTitle = null;
		if (_.has(this.props.stackSpecs, this.state.value)) {
			pickTitle = this.props.stackSpecs[this.state.value]['Stack size'];
		} else {
			pickTitle = (<em>Choose stack size</em>)
		}
		var pickerClass = "stack-picker";
		if (this.state.optionsExpanded) {
			pickerClass += " stack-picker-toggled";
		}
		return (
			<div className={pickerClass} tabIndex="-1" onBlur={this.onBlur} ref="inputElement">
				{alert}
				<div className={className} onClick={this.onClick} >
					{pickTitle}
				</div>

				<div className="table-responsive stack-picker-options" tabIndex="-1">
					<table className="table">
						<StackPickerInfoRows stackSpecs={this.props.stackSpecs} enabledTypes={this.props.enabledTypes}/>
						<StackPickerPickRow stackSpecs={this.props.stackSpecs} enabledTypes={this.props.enabledTypes}
							disabledReason={this.props.disabledReason}
							value={this.state.value}
							changeHandler={this.onChange}
							/>
					</table>
				</div>
			</div>
		);
	}
});

var StackPickerInfoRows = createReactClass({

	render: function() {
		var self = this;
		var firstCode = _.keys(this.props.stackSpecs)[0];
		var headings = _.keys(this.props.stackSpecs[firstCode]);

		var rows = _.map(headings, function(heading) {
			return (
				<StackPickerRow key={heading} stackSpecs={self.props.stackSpecs} enabledTypes={self.props.enabledTypes} heading={heading}/>
			);
		});

		return (
			<tbody>
				{rows}
			</tbody>
		)
	}

});

var StackPickerPickRow = createReactClass({

	render: function() {
		var self = this;

		// Create the selector row - can also disable some options and display "disabledReason".
		var choices = [];
		var disabledCount = 0;
		_.keys(this.props.stackSpecs).forEach(function(code) {
			if (!_.isArray(self.props.enabledTypes) || _.contains(self.props.enabledTypes, code)) {
				if (disabledCount>0) {
					choices.push(<td key={'disabled-' + disabledCount + '-' + code} className="stack-picker-disabled" colSpan={disabledCount}>{self.props.disabledReason}</td>);
					disabledCount = 0;
				}
				var id = self.props.name + '_' + code;
				choices.push(
					<td key={code}>
						<input id={id} type="radio" value={code} name={self.props.name}
							onChange={self.props.changeHandler}
							checked={self.props.value===code}
							/>
					</td>
				);
			} else {
				disabledCount++;
			}
		});

		// Catch possible final disabled pick.
		if (disabledCount>0) {
			choices.push(<td key={'last-disabled-' + disabledCount} className="stack-picker-disabled" colSpan={disabledCount}>{self.props.disabledReason}</td>);
		}

		return (
			<tfoot>
				<tr>
					<th>&nbsp;</th>
					{choices}
				</tr>
			</tfoot>
		);
	}

});

var StackPickerRow = createReactClass({
	render: function() {
		var self = this;
		var items = [];
		_.keys(this.props.stackSpecs).forEach(function(code) {

			var enabled = !_.isArray(self.props.enabledTypes) || _.contains(self.props.enabledTypes, code)

			if (_.has(self.props.stackSpecs[code], self.props.heading)) {
				var value = self.props.stackSpecs[code][self.props.heading];
				if (typeof value==='boolean') {
					value = value ? (<i className="fa fa-check"></i>) : (<i className="fa fa-times"></i>)
				}
			} else {
				var value = '';
			}

			items.push(
					<td key={code + '-' + enabled} className={enabled ? '' : 'stack-picker-disabled'}>{value}</td>
			);
		});

		return (
			<tr>
				<th><label dangerouslySetInnerHTML={{__html:this.props.heading}}/></th>
				{items}
			</tr>
		);
	}
});

module.exports = StackPicker;
